export default "__VITE_ASSET__CfasVF76__"